const STORAGE_VERSION = 1;
export const LAST_VISITED_URL_KEY = `vroom-last-visited-url-v${STORAGE_VERSION}`;
export const LAST_VISITED_URL_TTL_MS = 1000 * 60 * 60; // 1 hour in milliseconds
